module.exports = require('./lib/xml-writer.js');